window.addEventListener('OpusCartChange', (event)=>{
    const data = event.detail;
    const itemsCount = data.item_count;
    const iconHeader = document.querySelector(".cart-link");
    const countHeader = iconHeader.querySelector(".cart-link__bubble--visible");
    if (!countHeader && itemsCount >= 0) { 
      const countHeader1 = iconHeader.querySelector(".cart-link__bubble");
      countHeader1.classList.add('cart-link__bubble--visible');
      countHeader1.textContent = itemsCount;
    }
});

